import { AbapInputUpdate, BaseQuery } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToAbapInputUpdate = (q: BaseQuery, assignee?: string): AbapInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    applicationComponent:
      q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.applicationComponent : '',
    collectionPackage:
      q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.collectionPackage : '',
    objectName: q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.objectName : '',
    objectOwner: q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.objectOwner : '',
    objectType: q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.objectType : '',
    repositoryProgramId:
      q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.repositoryProgramId : '',
    repositoryProgramName:
      q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.repositoryProgramName : '',
    repositoryProgramType:
      q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.repositoryProgramType : '',
    system: q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.system : '',
    translationArea:
      q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.translationArea : '',
    maxLength: q.queryDetails?.__typename === 'AbapQuery' ? q.queryDetails?.maxLength : undefined
  };
};
